import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemHighlightIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.49 18.89L12.68 0.669999C12.43 0.149999 11.58 0.149999 11.33 0.669999L2.50997 18.89C1.89997 20.14 2.40997 21.67 3.62997 22.29C5.41997 23.2 8.54997 23.75 12 23.75C15.45 23.75 18.58 23.21 20.37 22.29C21.59 21.67 22.1 20.14 21.49 18.89ZM19.69 20.96C18.12 21.76 15.18 22.25 12 22.25C8.81997 22.25 5.87997 21.75 4.30997 20.96C3.80997 20.7 3.60997 20.07 3.85997 19.55L12 2.72L20.14 19.55C20.39 20.07 20.19 20.71 19.69 20.96Z"
        fill={color}
      />
      <path
        d="M12.31 11.46C12.12 11.35 11.88 11.35 11.68 11.46L7.81 13.71C7.62 13.82 7.5 14.03 7.5 14.25V18.75C7.5 18.97 7.62 19.18 7.81 19.29L11.68 21.54C11.87 21.65 12.11 21.65 12.31 21.54L16.18 19.29C16.37 19.18 16.49 18.97 16.49 18.75V14.25C16.49 14.03 16.37 13.82 16.18 13.71L12.31 11.46ZM12 12.72L14.65 14.26L12 15.78L9.35 14.26L12 12.72ZM8.75 15.37L11.37 16.87V19.92L8.75 18.4V15.38V15.37ZM12.62 19.91V16.86L15.24 15.36V18.38L12.62 19.9V19.91Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemHighlightIcon.displayName = 'ItemHighlightIcon';
